import React from 'react';

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  type = 'button',
  ...rest
}) {
  const classes = `btn btn--${variant} btn--${size} ${className}`.trim();
  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}

export function IconButton({ className = '', size = 'md', children, ...rest }) {
  return (
    <Button variant="icon" size={size} className={className} {...rest}>
      {children}
    </Button>
  );
}

export function Fab({ className = '', children, ...rest }) {
  return (
    <Button variant="fab" className={className} {...rest}>
      {children}
    </Button>
  );
}
